module.exports = __webpack_public_path__ + "img/Cyber-Shield_group.96d4be54.jpg";